/**
 * @generated SignedSource<<cc7224c5cd9f7283724c6820d824c81f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type sourcesPage_SwitchoverMutation$variables = {
  action: string;
};
export type sourcesPage_SwitchoverMutation$data = {
  readonly sourcingSwitchover: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly ok: boolean;
    readonly preview: {
      readonly autoFilled: number;
      readonly batchId: string;
      readonly claimed: number;
      readonly demoted: number;
      readonly flagged: number;
      readonly matched: number;
      readonly pending: number;
    } | null | undefined;
  } | null | undefined;
};
export type sourcesPage_SwitchoverMutation = {
  response: sourcesPage_SwitchoverMutation$data;
  variables: sourcesPage_SwitchoverMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "action"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "action",
    "variableName": "action"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ok",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "batchId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "matched",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "claimed",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "autoFilled",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "flagged",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pending",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "demoted",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "sourcesPage_SwitchoverMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SourcingSwitchoverMutationPayload",
        "kind": "LinkedField",
        "name": "sourcingSwitchover",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SourcingSwitchoverPreview",
            "kind": "LinkedField",
            "name": "preview",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v10/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "sourcesPage_SwitchoverMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SourcingSwitchoverMutationPayload",
        "kind": "LinkedField",
        "name": "sourcingSwitchover",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SourcingSwitchoverPreview",
            "kind": "LinkedField",
            "name": "preview",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v11/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v10/*: any*/),
              (v11/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d7dc619235fc3f1a14ccaced416fd5ea",
    "id": null,
    "metadata": {},
    "name": "sourcesPage_SwitchoverMutation",
    "operationKind": "mutation",
    "text": "mutation sourcesPage_SwitchoverMutation(\n  $action: String!\n) {\n  sourcingSwitchover(action: $action) {\n    ok\n    preview {\n      batchId\n      matched\n      claimed\n      autoFilled\n      flagged\n      pending\n      demoted\n      id\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f0884dd40ccb8f4ed74a5a6d8255e102";

export default node;
